// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"113":"db99fa76","224":"7ce73975","238":"5eb26e18","342":"ed6472b3","421":"1a356cc7","632":"5fb6afbe","644":"dc447a77","766":"a927e105","896":"b6bda43e"}[chunkId] + ".chunk.js";
};